import { AbstractControl, ValidatorFn } from "@angular/forms";

export function requiredIfValidator(validatedField: string, whenPresentField: string, whenPresentFieldLabel: string): ValidatorFn {
    return (abstractControl: AbstractControl) => {
        const validatedControl = abstractControl.get(validatedField);
        const otherControl = abstractControl.get(whenPresentField);

        if (validatedControl!.errors && !validatedControl!.errors?.['requiredIf']) {
            return null;
        }
        if (otherControl?.value && !validatedControl?.value) {
          const error = { otherTypeRequired: `Field is required when ${whenPresentFieldLabel} is filled.` };
          validatedControl!.setErrors(error);
          return error;
        } else {
          validatedControl!.setErrors(null);
          return null;
        }
    }
  }